import { Button } from '@app/app/_components/Button/Button';
import { ArrowRightIcon } from '@app/app/_icons/ArrowRightIcon';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchaseLifeInsuranceResult } from '@app/service/eshop/life/actions/purchaseLifeInsurance';
import { useTranslations } from 'next-intl';
import { saveProgressWithEmail } from '@app/service/eshop/life/actions/saveProgressWithEmail';
import { FormStatus } from '@app/lib/form/contracts/FormStatus';
import { AuthState } from '@app/infrastructure/auth/model/AuthState';
import { useEffect } from 'react';
import { pushToDataLayer } from '@app/infrastructure/gtm/pushToDataLayer';
import { getLifeStepGtmData } from '@app/infrastructure/gtm/life/trackLifeFunnelStep';

interface Props {
    formState: FormState<PurchaseLifeInsuranceResult>;
    handleSuccess: () => void;
    authState: AuthState;
    currentStepKey: string;
}

export function MidFormFinishFooter({ formState, handleSuccess, authState, currentStepKey }: Props) {
    const t = useTranslations();

    useEffect(() => {
        const data = getLifeStepGtmData(currentStepKey);

        if (!data) {
            return;
        }

        pushToDataLayer('form_save_continue', {
            flow_name: 'life_insurance',
            ...data,
        });
    }, [currentStepKey]);

    const handleSubmit = async () => {
        const formData = new FormData();
        formData.append('email', formState.data?.formData.email || '');

        if (!formState.data?.formData || !formState.data?.packages) {
            return;
        }

        const result = await saveProgressWithEmail(
            formState.data.formData,
            formState.data.packages,
            { status: FormStatus.Pending },
            formData,
            authState,
        );

        if (result.status === FormStatus.Success) {
            const data = getLifeStepGtmData(currentStepKey);

            if (data) {
                pushToDataLayer('form_save_continue_submit', {
                    flow_name: 'life_insurance',
                    ...data,
                });
            }

            handleSuccess();
        }
    };

    if (!formState.data?.formData || !formState.data?.packages) {
        return null;
    }

    return (
        <>
            <div className="flex w-full flex-col gap-4 sm:flex-row">
                <Button onClick={handleSubmit} className="w-full" rightAddon={<ArrowRightIcon className="size-4" />}>
                    {t('eshop.life.sendTheForm')}
                </Button>
            </div>
        </>
    );
}
